import React, { useEffect } from "react";
import "../../styles/components/SideBarLeftTopContent.scss";
const SideBarLeftTopContent = (props) => {
  const {
    handleOpenElement,
    bgClass,
    setBgClass,
    setSelectedIndex,
    playPauseRef,
    setIsNext,
    isModuleExist,
    getEditSaveAssets,
    bannerId,
    setSelectedModule,
    setNotUsedEditorToggle,
    notUsedEditorToggle,
    isOneTimeAsset,
  } = props;

  // commenting this since the same api has been called once in EditorMainPage.js
  // useEffect(() => { 
  //   if (!isModuleExist) {
  //     getEditSaveAssets(bannerId);
  //   }
  // }, [isModuleExist]);

  useEffect(() => {
    if (isOneTimeAsset) {
      setBgClass(true);
      setIsNext(false);
      setSelectedModule(undefined);
    }
  }, [isOneTimeAsset]);

  return (
    <div className="format-content">
      <div
        className={
          props.showAssettype === "Banner" && !isOneTimeAsset
            ? "format-content-boder"
            : "format-content-boder noContent"
        }
      >
        <div
          className={`format-div ${bgClass ? "bgColorClass" : ""} ${
            props.showAssettype === "Template" || isOneTimeAsset
              ? "noContent"
              : ""
          }`}
          style={{
            borderTopRightRadius:
              bgClass || isOneTimeAsset || props.showAssettype !== "Banner"
                ? "6px"
                : "0px",
            borderBottomRightRadius:
              bgClass || isOneTimeAsset || props.showAssettype !== "Banner"
                ? "6px"
                : "0px",
            ...(isOneTimeAsset && { pointerEvents: "none", cursor: "default" }),
          }}
          onClick={() => {
            if (isOneTimeAsset) return;
            if (notUsedEditorToggle) {
              setNotUsedEditorToggle(false);
            }
            setBgClass(true);
            if (playPauseRef.current.animationCompleted) {
              handleOpenElement("Text");
              setSelectedIndex(0);
            }
            setIsNext(false);
            setSelectedModule(undefined);
          }}
        >
          {" "}
          FORMAT
        </div>
        {props.showAssettype === "Banner" && !isOneTimeAsset ? (
          <div
            className={`content-div ${!bgClass ? "bgColorClass" : ""}`}
            style={{
              borderTopLeftRadius: !bgClass ? "6px" : "0px",
              borderBottomLeftRadius: !bgClass ? "6px" : "0px",
            }}
            onClick={() => {
              setBgClass(false);
              if (playPauseRef.current.animationCompleted) {
                setSelectedIndex(-1);
                if (!isModuleExist) {
                  getEditSaveAssets(bannerId);
                  handleOpenElement("Module");
                } else {
                  handleOpenElement("");
                  setIsNext(true);
                }
              }
            }}
          >
            CONTENT
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
export default SideBarLeftTopContent;
